import React, { createContext, useContext, useMemo } from "react";
import { useTenantBootstrap } from "./TenantBootstrapContext";

const CompanyContext = createContext();

export const useCompanyContext = () => useContext(CompanyContext);

export const CompanyProvider = ({ children }) => {
  const { tenantBootstrap, source } = useTenantBootstrap();

  const value = useMemo(
    () => ({
      // A cached data URL is self-contained; never request a remote logo in offline mode.
      companyLogo:
        tenantBootstrap?.companyLogoDataUrl ||
        (source === "cache" ? null : tenantBootstrap?.companyLogoUrl) ||
        null,
      companyName: tenantBootstrap?.clientName || null,
    }),
    [source, tenantBootstrap]
  );

  return (
    <CompanyContext.Provider value={value}>{children}</CompanyContext.Provider>
  );
};
